import { IncreaseCreditLimitNZParam } from "components/IncreaseCreditLimit/NzForm";
import { createTicket } from "library/api/zendesk/zendesk";
import { getIsProduction } from "library/browser";
import { formatPayload } from "./formatPayload";

export async function createIncreaseCreditLimitNZTicket(
  fields: IncreaseCreditLimitNZParam,
) {
  const isProduction = getIsProduction();
  const envKey = isProduction ? "prod" : "nonProd";
  const payload = formatPayload(fields, envKey);
  const ticketResponse = await createTicket(payload, fields.token);
  return ticketResponse.data.ticket_id;
}
